export const selectbutton = {
  root: {
    borderRadius: "{form.field.border.radius}",
  },
  colorScheme: {
    light: {
      root: {
        invalidBorderColor: "{form.field.invalid.border.color}",
      },
    },
    dark: {
      root: {
        invalidBorderColor: "{form.field.invalid.border.color}",
      },
    },
  },
  css: (): string => `
    .p-selectbutton-fluid {
      width: 100%;
    }

    .p-selectbutton-fluid .p-togglebutton {
      flex: 1;
    }
  `,
};
